// extracted by mini-css-extract-plugin
export var background = "_6v-0";
export var container = "_6v-1";
export var contentItem = "_6v-7";
export var extendedWarranty = "_6v-5";
export var link = "_6v-d";
export var modal = "_6v-b";
export var modalCloseButton = "_6v-9";
export var modalContent = "_6v-3";
export var modalContentMain = "_6v-6";
export var modalImageLogo = "_6v-8";
export var modalLogo = "_6v-a";
export var modalSideImage = "_6v-4";
export var preview = "_6v-c";
export var redoModal = "_6v-2";